/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import Decimal from '../../../../../components/form/elements/decimal';
import InputDate from '../../../../../components/form/elements/date';
import { CalendarImage } from '../../../../../assets/icons/insex';
import Watch from '../../../../../components/form/elements/watch';

function calculateEndDate(startDate: Date, days: number): string | null {
  const start = new Date(startDate);

  start.setDate(start.getDate() + days);

  if (isNaN(start.getTime())) {
    console.error('Invalid start date provided');
    return null;
  }

  const endDate = start.toISOString().split('T')[0];
  return endDate;
}

const RestrictionSectionLabel = ({
  label,
  dateToKey,
  dateFromKey,
  daysKey,
}: any) => {
  const { watch, setValue } = useFormContext();
  const [endDate, setEnddate] = useState('');
  const dateFrom = watch(dateFromKey);
  const days = Number(watch(daysKey));

  useEffect(() => {
    if (!!dateFrom && !!days) {
      const newEndDate = calculateEndDate(dateFrom, days - 1);
      if (newEndDate !== endDate) {
        const date = newEndDate.split('-');
        const dateTo = `${date[2]}.${date[1]}.${date[0]}`;
        setEnddate(dateTo);

        setValue(dateToKey, newEndDate);
      }
    }
  }, [dateFrom, days, endDate]);

  return (
    <div>
      <div className="flex flex-row justify-between my-1 form-field_label__">
        <label className="basis-1/2">{label}</label>
        <span className="basis-1/4 text-[#12589F] font-medium text-right">
          {endDate}
        </span>
      </div>
    </div>
  );
};

const DateForm = ({ dateFromKey, label, dateToKey, daysKey, tp, ...rest }) => {
  const DateFrom = useMemo(
    () =>
      InputDate(
        dateFromKey,
        null,
        null,
        null,
        true,
        CalendarImage,
        true,
        false,
        tp('events.date')
      ),
    []
  );

  const Days = useMemo(
    () =>
      Watch(
        Decimal(
          daysKey,
          null,
          null,
          null,
          true,
          false,
          tp('events.separation.numberOfDays')
        ),
        ({ setValue, value }) => {
          const transformValue = value.split('.')[0];

          setValue(daysKey, transformValue);
        }
      ),
    []
  );

  return (
    <div>
      <RestrictionSectionLabel
        dateFromKey={dateFromKey}
        label={label}
        dateToKey={dateToKey}
        daysKey={daysKey}
      />

      <div className="flex gap-1" style={{ marginTop: '1px' }}>
        <span className="flex-1">
          <DateFrom {...rest} />
        </span>
        <span className="flex-1">
          <Days {...rest} />
        </span>
      </div>
    </div>
  );
};

export default DateForm;
